import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector } from 'react-redux';

import {
  getLoadingTrafficStatusMapV2,
  getLoadingTrafficStatusRectangle,
  getLoadingTrafficStatusCircle,
} from '../../../../state/selectors/trafficStatusMap.selector';
import { StyledWrapper } from './LoadingTrafficStatus.styled';

const LoadingTrafficStatus = (props) => {
  const isLoadingTrafficStatus = useSelector(getLoadingTrafficStatusMapV2);
  const isLoadingTrafficStatusRectangle = useSelector(
    getLoadingTrafficStatusRectangle
  );
  const isLoadingTrafficStatusCircle = useSelector(
    getLoadingTrafficStatusCircle
  );
  return (
    <>
      {(isLoadingTrafficStatus ||
        isLoadingTrafficStatusRectangle ||
        isLoadingTrafficStatusCircle) && (
        <StyledWrapper> 
          <CircularProgress color='secondary' />
        </StyledWrapper>
      )}
    </>
  );
};

export default LoadingTrafficStatus;
